import {ValueObject} from '@s-ui/domain'

import {SeoLinkValueObject} from './SeoLinkValueObject.js'

export class ListSeoLinkValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({canonical}) {
    const links = []
    if (canonical) {
      links.push({rel: 'canonical', href: canonical})
    }
    return new ListSeoLinkValueObject({value: links.map(SeoLinkValueObject.create)})
  }

  get value() {
    return this.#value.map(link => link.value)
  }

  toJSON() {
    return {value: this.#value.map(link => link.toJSON())}
  }
}
